/* Account settings use each host application's authenticated API client. */
function validate(vm) {
  vm.$v.$touch();
  vm.tabsWithErrors = [];
  vm.passwordFormatError = Boolean(vm.password && (
    vm.password.length < 8 || !/[a-z]/.test(vm.password) ||
    !/[A-Z]/.test(vm.password) || !/[0-9]/.test(vm.password)
  ));
  vm.passwordMatchError = vm.password !== vm.passwordConfirm;

  const sections = [
    [vm.$v.name.$invalid || vm.$v.email.$invalid, 'frontend_sites_account_modal_personal_info'],
    [vm.$v.contactDetails.$invalid, 'frontend_sites_account_modal_contact_details'],
    [vm.$v.socialMedia.$invalid, 'frontend_sites_account_modal_socail_media'],
    [vm.$v.businessInfo.$invalid, 'frontend_sites_account_modal_business_details'],
    [vm.passwordFormatError || vm.passwordMatchError, 'frontend_sites_account_modal_change_password'],
  ];
  sections.forEach(([invalid, label]) => {
    if (invalid) vm.tabsWithErrors.push(vm.$t(label));
  });
  return !vm.$v.$invalid && !vm.passwordFormatError && !vm.passwordMatchError;
}

export function createAccountSave({ api, Auth, Notify, getApiUrl = () => window.gdEnv.VUE_APP_API_URL }) {
  return async function saveAccount() {
    if (this.isLoading) return false;
    this.accountSaveError = '';
    if (!validate(this)) return false;

    this.isLoading = true;
    let identitySaved = false;
    let metadataSaved = false;
    try {
      const current = Auth.authenticatedUser() || {};
      if (!this.userId || !current.id || String(this.userId) !== String(current.id)) {
        this.accountSaveError = 'Your account session has changed. Please reopen settings before saving.';
        return false;
      }
      // The account email is read-only in this dialog. A stale draft must not
      // change it back or invalidate the email claim in the current session.
      if (this.email !== current.email) {
        this.accountSaveError = 'Your account email has changed. Please reopen settings. Contact support if you need to change your email address.';
        return false;
      }

      // Snapshot the draft so changes typed during a request cannot enter a
      // different request or overwrite the identity that actually saved.
      const identity = { name: this.name, email: this.email };
      const password = this.password;
      const metadata = {
        business_info: { ...this.businessInfo },
        social_media: { ...this.socialMedia },
        contact_details: { ...this.contactDetails },
      };
      if (this.profilePicture) metadata.profile_picture = this.profilePicture;
      const base = getApiUrl().replace(/\/$/, '') + '/groovedigital/auth/users';

      if (identity.name !== current.name || identity.email !== current.email || password) {
        if (password) identity.password = password;
        await api.post(`${base}/update-user`, identity);
        identitySaved = true;
        // Do not submit an already-saved password again if metadata fails.
        if (this.password === password) this.password = '';
        if (this.passwordConfirm === password) this.passwordConfirm = '';
        Auth.updateDetails(identity.name, identity.email);
      }

      const result = await api.post(`${base}/update-meta/${encodeURIComponent(this.userId)}`, metadata);
      metadataSaved = true;
      Auth.updateMeta(result);
      Notify.success('Details Updated');
      return true;
    } catch (error) {
      if (metadataSaved) {
        this.accountSaveError = 'Your settings were saved, but the account display could not refresh. Please reopen settings.';
      } else if (identitySaved) {
        this.accountSaveError = 'Your profile changes were saved, but the remaining settings could not be saved. Your entries are still here. Please try again.';
      } else {
        this.accountSaveError = 'Your settings could not be saved. Your entries are still here. Please try again.';
      }
      // Avoid rendering server diagnostics or an Error object as HTML.
      Notify.fail(this.accountSaveError);
      return false;
    } finally {
      this.isLoading = false;
    }
  };
}
